import { Injectable } from '@angular/core';
import { MCCodeListWrapperService } from '@maslul/common-services';
import { map, Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class ApprovalTypeService {

    constructor(private codeListService: MCCodeListWrapperService) {

    }

    getInfoByKey(key: string): Observable<string> {
        return this.codeListService.getListAllColums("infoMyImport").pipe(map((res) => {
            return res.find(item => item.label == key)?.additionalColumns["info"]?.toString();
        }));
    }

}
